import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cart-widget__items__item" }
const _hoisted_2 = {
  class: "col-12 col-xl",
  ref: "colLeft"
}
const _hoisted_3 = { class: "cart-widget__items__item__title" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "text-end" }
const _hoisted_6 = { class: "cart-widget__items__item__prices" }
const _hoisted_7 = { class: "row g-0" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "yearly" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, " Ø pro Monat ", -1)
const _hoisted_11 = { class: "col-6" }
const _hoisted_12 = { class: "monthly" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, " pro Jahr ", -1)

import {
  PropType,
} from 'vue';
import { Product } from '@/classes';
import Expand from '@/components/Expand.vue';
import PriceDetailsTable from '@/components/product/PriceDetailsTable.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartItem',
  props: {
  itemKey: {
    type: String,
    required: true,
  },
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
},
  emits: ['remove'],
  setup(__props, { emit }) {

library.add(faTrashAlt);





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          innerHTML: __props.product.name
        }, null, 8, _hoisted_4),
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn-remove-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('remove')))
          }, [
            _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-trash-alt" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createTextVNode(_toDisplayString(__props.product.getPriceFormatted('monthly')) + " € ", 1),
              _hoisted_10
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createTextVNode(_toDisplayString(__props.product.getPriceFormatted('yearly')) + " € ", 1),
              _hoisted_13
            ])
          ])
        ])
      ]),
      _createVNode(Expand, null, {
        title: _withCtx(() => [
          _createTextVNode("Produktdetails")
        ]),
        default: _withCtx(() => [
          _createVNode(PriceDetailsTable, { product: __props.product }, null, 8, ["product"])
        ]),
        _: 1
      })
    ], 512)
  ]))
}
}

})